import { render, staticRenderFns } from "./Homeindex.vue?vue&type=template&id=63283119&"
import script from "./Homeindex.vue?vue&type=script&lang=js&"
export * from "./Homeindex.vue?vue&type=script&lang=js&"
import style0 from "./Homeindex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports